module.exports = __webpack_public_path__ + "static/slika-1-9c64634dec708c8e80ee68f520609243.png";